// utils/socket.js
import { io } from "socket.io-client";
import { API_SERVER } from "./config";

const user = JSON.parse(localStorage.getItem("travelo_user") || "{}");
const token = localStorage.getItem("travelo_token"); // align with rest of app

const socket = io( process.env.REACT_APP_SOCKET_SERVER || `${API_SERVER}` , {
  transports: ["websocket"],
  withCredentials: true,
  auth: {
    token,
    userId: user?._id || user?.id,
  },
});

export default socket;